import { defineAction } from '~/prix'
import { z } from 'zod'
import semenStockDeleteAction from './semenStockDelete.action.json' with { type: 'json' }
import { semenStockObject } from '../semenStockObject'

const semenStockDeleteDefinition = defineAction({
  ...semenStockDeleteAction,

  input: z.object({ id: semenStockObject.shape.id }),
  output: z.object({}),
})

export default semenStockDeleteDefinition
